var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageName',{attrs:{"title":_vm.pageName,"buttons":_vm.buttons}}),(_vm.userLoading)?_c('Preloader'):_c('Profile',{attrs:{"user":_vm.user,"info":_vm.userInfo}}),(_vm.changePasswordDialog)?_c('PasswordModal',{attrs:{"request":_vm.changePassword},on:{"close":function($event){_vm.changePasswordDialog = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }